module.exports = __webpack_public_path__ + "img/coporate-social-responsibility-v2.b58d60ac.jpg";